function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M401.7,166.2h-73.3c-6.6,0-12,5.4-12,12s5.4,12,12,12h72.1v204.6h-319V190.2h72.3c6.6,0,12-5.4,12-12s-5.4-12-12-12H80.3 c-12.6,0-22.8,10.2-22.8,22.8v207c0,12.6,10.2,22.8,22.8,22.8H229V458h-61.4c-6.6,0-12,5.4-12,12s5.4,12,12,12h146.7 c6.6,0,12-5.4,12-12s-5.4-12-12-12H253v-39.2h148.7c12.6,0,22.8-10.2,22.8-22.8V189.1C424.5,176.5,414.3,166.2,401.7,166.2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M241,324.2c-3.2,0-6.3,1.3-8.5,3.5s-3.5,5.3-3.5,8.5s1.3,6.3,3.5,8.5s5.3,3.5,8.5,3.5c3.2,0,6.3-1.3,8.5-3.5 s3.5-5.3,3.5-8.5s-1.3-6.3-3.5-8.5S244.2,324.2,241,324.2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M241,230.6c-6.6,0-12,5.4-12,12s5.4,12,12,12s12-5.4,12-12S247.6,230.6,241,230.6z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M241,90.3c-6.6,0-12,5.4-12,12s5.4,12,12,12s12-5.4,12-12C253,95.6,247.6,90.3,241,90.3z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M241,137.1c-6.6,0-12,5.4-12,12s5.4,12,12,12s12-5.4,12-12C253,142.4,247.6,137.1,241,137.1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M241,277.4c-6.6,0-12,5.4-12,12s5.4,12,12,12s12-5.4,12-12S247.6,277.4,241,277.4z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M241,183.9c-6.6,0-12,5.4-12,12s5.4,12,12,12s12-5.4,12-12C253,189.2,247.6,183.9,241,183.9z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M240.2,67.5c0.3,0,0.5,0,0.8,0l0,0c18.2,0,33.3-14.8,33.7-32.9c0.2-9-3.1-17.6-9.3-24.1C259.2,4,250.8,0.3,241.8,0 c-0.3,0-0.5,0-0.8,0c-18.2,0-33.3,14.8-33.7,32.9c-0.2,9,3.1,17.6,9.3,24.1C222.8,63.5,231.2,67.3,240.2,67.5z M241,24h0.2 c2.6,0.1,5,1.1,6.8,3s2.8,4.4,2.7,7c-0.1,5.2-4.5,9.5-9.7,9.5h-0.2c-2.6-0.1-5-1.1-6.8-3s-2.8-4.4-2.7-7 C231.4,28.3,235.8,24,241,24z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M289.1,297.3c6.6,0,12-5.4,12-12V117.2c0-6.8,5.6-12.4,12.4-12.4h23.9c4.8,12.7,17.2,21.7,31.5,21.7 c18.6,0,33.7-15.1,33.7-33.7s-15-33.7-33.6-33.7c-14.4,0-26.7,9-31.5,21.7h-23.9c-20.1,0-36.4,16.3-36.4,36.4v168.1 C277.1,292,282.5,297.3,289.1,297.3z M369,83.1c5.4,0,9.7,4.4,9.7,9.7s-4.4,9.7-9.7,9.7c-5.4,0-9.7-4.4-9.7-9.7 S363.6,83.1,369,83.1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M113,126.6c14.4,0,26.7-9,31.5-21.7h23.9c6.8,0,12.4,5.6,12.4,12.4v168.1c0,6.6,5.4,12,12,12s12-5.4,12-12V117.2 c0-20.1-16.3-36.4-36.4-36.4h-23.9c-4.8-12.7-17.2-21.7-31.5-21.7c-18.6,0-33.7,15.1-33.7,33.7S94.4,126.6,113,126.6z M113,83.1 c5.4,0,9.7,4.4,9.7,9.7s-4.4,9.7-9.7,9.7s-9.7-4.4-9.7-9.7S107.7,83.1,113,83.1z"
}));

var SvgIconProceedings = function SvgIconProceedings(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 482 482",
    style: {
      enableBackground: "new 0 0 482 482"
    },
    xmlSpace: "preserve",
    width: 24,
    height: 25,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconProceedings, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_proceedings.c81f4ff8.svg";
export { ForwardRef as ReactComponent };